import {repository} from 'aurelia-orm';
import {ThemeColor} from "./theme-color";
import { ItemTypeBase } from "./item-type-base";

@repository(ItemType)
export class ItemType extends ItemTypeBase {
    showProperties: boolean;
    showChildren: boolean;
    icon: string;
    template: string;
}